import React, { createContext, useState, useContext, useEffect } from 'react';
import { auth } from '../firebase';
import axios from 'axios';

const UserContext = createContext();

export const UserProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [authCompleted, setAuthCompleted] = useState(false);

  const apiUrl = process.env.REACT_APP_API_URL;

  // Función para establecer el usuario de LinkedIn
  const setLinkedInUser = async (linkedInUser) => {
    try {
      // Primero verificamos si el usuario ya existe en la base de datos
      var userUID = localStorage.getItem("userUID")
      console.log("USER LINKEDIN: ", userUID)
      const response = await axios.get(`${apiUrl}/collections/user/${userUID}`);
      
      if (response.data) {
        let businessResponse;
        try {
          businessResponse = await axios.get(`${apiUrl}/collections/todo_restaurantes_españa/${response.data?.businessId}`);
        } catch (error) {
          console.error('Error fetching business data:', error);
        }

        const parseDate = (dateString) => {
          const [day, month, year] = dateString.split('/').map(Number);
          return new Date(year, month - 1, day); // Los meses en JavaScript son indexados desde 0
        };

        const registrationDate = parseDate(response.data?.date);
        const expirationDate = new Date(registrationDate);
        expirationDate.setDate(expirationDate.getDate() + 7);
        const currentDate = new Date();
        const isExpired = (currentDate > expirationDate);

        // Si existe, usamos los datos de la base de datos
        setUser({
          ...linkedInUser,
          email: response.data?.email || "",
          id_negocio: response.data?.id_negocio || "",
          businessId: response.data?.businessId || "",
          is_premium: response.data?.is_premium || false,
          business_data: businessResponse?.data || '',
          date: response.data?.date,
          reports: response.data?.reports,
          direccion: response.data?.direccion || "",
          telefono: response.data?.telefono || "",
          nombre_usuario: response.data?.nombre_usuario,
          mail_contacto: response.data?.mail_contacto,
          is_expired: isExpired,
          provider: 'linkedin'
        });
      } else {
        // Si no existe, usamos los datos básicos
        setUser({
          ...linkedInUser,
          id_negocio: '',
          businessId: '',
          provider: 'linkedin'
        });
      }
      setLoading(false);
    } catch (error) {
      console.error('Error setting LinkedIn user:', error);
      setUser({
        ...linkedInUser,
        provider: 'linkedin'
      });
      setLoading(false);
    }
  };

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged(async (firebaseUser) => {
      setLoading(true);
      console.log("Firebase User:", firebaseUser);
  
      // If no Firebase user, check localStorage
      const userUID = firebaseUser?.uid || localStorage.getItem("userUID");
      console.log("UserUID:", userUID);
  
      // If no user at all, set to null and stop loading
      if (!userUID) {
        setUser(null);
        setLoading(false);
        return;
      }
  
      try {
        // Try to fetch user data
        const response = await axios.get(`${apiUrl}/collections/user/${userUID}`);
        console.log("Database response:", response.data);
  
        // If Firebase user exists
        if (firebaseUser) {
          let businessResponse;
          try {
            businessResponse = await axios.get(`${apiUrl}/collections/todo_restaurantes_españa/${response.data?.businessId}`);
          } catch (error) {
            console.error('Error fetching business data:', error);
          }

          const parseDate = (dateString) => {
            const [day, month, year] = dateString.split('/').map(Number);
            return new Date(year, month - 1, day); // Los meses en JavaScript son indexados desde 0
          };
  
          const registrationDate = parseDate(response.data?.date);
          const expirationDate = new Date(registrationDate);
          expirationDate.setDate(expirationDate.getDate() + 7);
          const currentDate = new Date();
          const isExpired = (currentDate > expirationDate);

          setUser({
            ...firebaseUser,
            email: response.data?.email || "",
            id_negocio: response.data?.id_negocio || '',
            businessId: response.data?.businessId || '',
            is_premium: response.data?.is_premium || false,
            business_data: businessResponse?.data || '',
            date: response.data?.date,
            reports: response.data?.reports,
            direccion: response.data?.direccion || "",
            telefono: response.data?.telefono || "",
            nombre_usuario: response.data?.nombre_usuario,
            mail_contacto: response.data?.mail_contacto,
            is_expired: isExpired,
            provider: 'firebase'
          });
        } 
        // If no Firebase user but we have data from localStorage
        else {
          setUser({
            ...response.data,
            uid: userUID,
            provider: 'linkedin'
          });
        }
      } catch (error) {
        console.error('Error fetching user data:', error);
        setUser(null);
      }
      
      setLoading(false);
    });
  
    return () => unsubscribe();
  }, [authCompleted]);
  
  return (
    <UserContext.Provider value={{ user, setUser: setLinkedInUser, loading, notifyAuthCompleted: () => setAuthCompleted((prev) => !prev) }}>
      {children}
    </UserContext.Provider>
  );
};

export const useUser = () => useContext(UserContext);